export default [
  {
    "id": "1G53E1mkIl5PK4j9z8Y7",
    "name": "Spot-Up Shooting z 5 pozycji",
    "description": "Rzuty ze stacjonarnych pozycji za 3 punkty (2x róg 2x skrzydełko 1x szczyt). Zawodnik oddaje po 5 rzutów z każdej pozycji i zmienia miejsce.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 15,
    "repetitions": 25,
    "youtubeUrl": "https://youtube.com/example/5-spot-shooting",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 278000000
    },
    "updatedAt": "2026-08-06T16:25:41.759Z"
  },
  {
    "id": "1MursxelRKuPgH9kFVVy",
    "name": "Tennis Ball Toss & Dribble (Złap piłeczkę)",
    "description": "Kozłowanie piłki do koszykówki jedną ręką podczas gdy druga ręka podrzuca i chwyta piłeczkę tenisową bez zatrzymywania kozła.",
    "category": "Koordynacja",
    "difficulty": "Trudne",
    "duration": 10,
    "repetitions": 6,
    "youtubeUrl": "https://youtube.com/example/tennis-ball-dribble",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "3mxrL4cWKw4dSqxeYWpH",
    "name": "Give and Go (Podaj i wyjdź na pozycję)",
    "description": "Podanie piłki ze skrzydełka do środka dynamiczne ścięcie obok obrońcy w kierunku kosza i odebranie podania zwrotnego na łatwy punkt.",
    "category": "Taktyka",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example/give-and-go",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "3u3cxjHrET04o5bB1Y3n",
    "name": "Rzuty z rogu po podaniu",
    "description": "Serie rzutów z obu rogów boiska po podaniu od partnera ze skrzydła lub ze środka. Akcent na szybkie ułożenie stóp i płynny wypust.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 24,
    "youtubeUrl": "https://youtube.com/example/corner-shooting",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 278000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "5JssRYj7Z3mXoTdTrWsV",
    "name": "Rozgrzewka klasyk",
    "description": "",
    "category": "Rozgrzewka",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 0,
    "youtubeUrl": "",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "SYj5H1QmQ0evN9QIp5PyH1yFh6B3",
    "createdBy": "Unknown",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785779758,
      "_nanoseconds": 204000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "786WIZLRWpXbQr1WrH97",
    "name": "Mobilizacja bioder i stawów skokowych w głębokim przysiadzie",
    "description": "Utrzymanie głębokiego przysiadu z rozpychaniem kolan łokciami i delikatnym przenoszeniem ciężaru ciała na boki dla zwiększenia zakresem w stawie skokowym.",
    "category": "Rozciąganie i Mobilność",
    "difficulty": "Łatwe",
    "duration": 6,
    "repetitions": 3,
    "youtubeUrl": "https://youtube.com/example/deep-squat-mobility",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 280000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "9ngrNLwuylmrE8Yp1Mpy",
    "name": "Backdoor Cut przeciwko mocnej presji",
    "description": "Reakcja na agresywne krycie obrońcy na linii podania – fałszywy wybieg na obwód i gwałtowne złamanie kierunku za plecy obrońcy do kosza.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example/backdoor-cut",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "A3gAj8vunOgYpd95m9z7",
    "name": "Dribble Hand-Off (DHO) ze ścięciem",
    "description": "Gracz kozłujący podaje piłkę 'z ręki do ręki' ścinającemu obwodowemu tworząc naturalną zasłonę i możliwość natychmiastowego wjazdu lub rzutu.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example/dribble-handoff",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "B7OUl4gPeYhymnsFrzSZ",
    "name": "Rzut po wyskoku z kozła (Pull-Up Jumper)",
    "description": "Dynamiczne wyjście z kozła gwałtowne zatrzymanie na dwie tempa lub na raz (jump stop) i rzut z półdystansu nad wyimaginowanym obrońcą.",
    "category": "Rzuty",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example/pullup-jumper",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 278000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "DWFuhMQo3PHG7LKzS4gC",
    "name": "Zagrywka Pick and Roll 2v2",
    "description": "Ćwiczenie dwójkowe rozgrywającego i wysokiego. Trening odczytywania obrony: rolowanie do kosza (roll) odejście na obwód (pop) lub rzut bezpośrednio po zasłonie.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 15,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example/pnr-2v2",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "IG6WCvvDhqQR0PI34y7y",
    "name": "Drybling dwiema piłkami w miejscu i ruchu",
    "description": "Kozłowanie dwiema piłkami jednocześnie (równolegle i naprzemiennie) na różnej wysokości (kolana, pas, klatka) – stacjonarnie oraz w marszu/truchcie.",
    "category": "Drybling",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 3,
    "youtubeUrl": "https://youtube.com/example/two-ball-dribble",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 275000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "K3pObiwTtTLPvXbSSzg7",
    "name": "Wykończenie przy koszu z kontaktem (Floater / Layup)",
    "description": "Wjazd pod kosz z wykończeniem floatrem (rzutem łezką) lub dwutaktem przy użyciu poduchy treningowej do imitacji kontaktu z obrońcą.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 16,
    "youtubeUrl": "https://youtube.com/example/contact-finish",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 278000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "MyZiLCVbRFBa5SW6oRzq",
    "name": "aa",
    "description": "",
    "category": "Ogólne",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "demo-admin",
    "createdBy": "SYj5H1QmQ0evN9QIp5PyH1yFh6B3",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785186996,
      "_nanoseconds": 533000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "NNvs3MoJdyib1UARuYz9",
    "name": "Drabinka koordynacyjna z kozłowaniem piłki",
    "description": "Przejście skomplikowanych wzorów na drabince koordynacyjnej (np. in-out icky shuffle) z jednoczesnym ciągłym kozłowaniem piłki koszykarskiej.",
    "category": "Koordynacja",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example/ladder-dribble",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "O4n3M7vRUXrr4RivygV5",
    "name": "Closeout i obrona penetracji",
    "description": "Dynamiczny doskok obrońcy do zawodnika na obwodzie ze skróceniem kroku pod koniec (closeout) a następnie reakcja na wjazd atakującego.",
    "category": "Obrona",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example/closeout-drill",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "OPPYALlGXICCQa7tqfwE",
    "name": "Rotacja w obronie ze strefy pomocy (Help & Recover)",
    "description": "Ćwiczenie rotacji zespołu: obrońca schodzi do pomocy przy penetracji w pole 3 sekund a następnie szybko wraca na obwód po odrzuceniu piłki.",
    "category": "Obrona",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example/help-and-recover",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "PDCKdPrfZ4aPIZfXSkrA",
    "name": "Światowy Najlepszy Stretch (World's Greatest Stretch)",
    "description": "Głęboki wykrok z opuszczeniem bioder dłoń na podłodze przy stopie i szeroka rotacja tułowia z wyciągnięciem ramienia w górę. Mobilizacja bioder i kręgosłupa.",
    "category": "Rozciąganie i Mobilność",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 6,
    "youtubeUrl": "https://youtube.com/example/worlds-greatest-stretch",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 280000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "UtGRE3rDGpdzXkCIEHh4",
    "name": "Zbiórka i ponowienie wyskoku przy tablicy (Tip-Ins)",
    "description": "Wyskok pod tablicą odbijanie piłki dłonią o tablicę w najwyższym punkcie wyskoku (5 powtórzeń w powietrzu) i dobitka do kosza.",
    "category": "Motoryka i Wyskok",
    "difficulty": "Średnie",
    "duration": 8,
    "repetitions": 6,
    "youtubeUrl": "https://youtube.com/example/backboard-tip-ins",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "X0nLR7uuD74X2A9GJEaL",
    "name": "Slalom ze stożkami i zmianami kierunku",
    "description": "Dynamiczny kozioł na torze przeszkód ze stożkami. Na każdym stożku wykonaj inną zmianę kierunku: przełożenie przed sobą pod nogą za plecami oraz zwód 'In & Out'.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 6,
    "youtubeUrl": "https://youtube.com/example/crossover-slalom",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 278000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "Zy94Lme4b6DImBBojP7t",
    "name": "Krok odstawno-dostawny po przekątnych (Slide Drill)",
    "description": "Poruszanie się nisko na nogach w pozycji obronnej zygzakiem od linii bocznej do środka boiska. Praca rąk w górze bez krzyżowania nóg.",
    "category": "Obrona",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 6,
    "youtubeUrl": "https://youtube.com/example/defensive-slides",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "aDhD5rIIjDQ2vbALLeGp",
    "name": "Statyczne rozciąganie taśmy tylnej (Ud i łydek)",
    "description": "Powolne statyczne rozciąganie mięśni dwugłowych ud oraz łydek po treningu. Pozycja utrzymywana przez 30 sekund na każdą nogę bez pulsowania.",
    "category": "Rozciąganie i Mobilność",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 4,
    "youtubeUrl": "https://youtube.com/example/hamstring-stretch",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 280000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "bAW5xLOrLOH88EMnXmbR",
    "name": "Atak szybki 3v2 przechodzący w 2v1 (Continuous Break)",
    "description": "Dynamiczny przewaga liczebna w kontrze. Trzech atakujących szuka szybkiego wykończenia przeciwko dwóm obrońcom. Po rzucie następuje powrót do obrony.",
    "category": "Taktyka",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 6,
    "youtubeUrl": "https://youtube.com/example/3v2-break",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "cZppzb4Jzme89ZX42ShP",
    "name": "Bieg wahadłowy 'Samobójce' (Suicide Runs)",
    "description": "Sprinty od linii końcowej do linii rzutów wolnych linii środkowej przeciwległej linii rzutów wolnych i przeciwległej linii końcowej z dotknięciem linii.",
    "category": "Motoryka i Wyskok",
    "difficulty": "Trudne",
    "duration": 12,
    "repetitions": 4,
    "youtubeUrl": "https://youtube.com/example/suicide-runs",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "eCxoBREeRmggDtX61sjU",
    "name": "Podania pod presją w kole (Bull in the Ring)",
    "description": "Trzech obwodowych podaje do siebie piłkę w wyznaczonym okręgu podczas gdy jeden obrońca w środku próbuje przeciąć podanie lub dotknąć piłki.",
    "category": "Podania",
    "difficulty": "Średnie",
    "duration": 8,
    "repetitions": 4,
    "youtubeUrl": "https://youtube.com/example/bull-in-the-ring",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 278000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "h6PywyL4aWzEpaXb4KSd",
    "name": "T-Drill z piłką (Praca reakcyjna i zwrotność)",
    "description": "Bieg po planie litery T z kozłowaniem piłki: sprint do przodu krok odstawno-dostawny w lewo w prawo powrót do środka i bieg tyłem.",
    "category": "Koordynacja",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 5,
    "youtubeUrl": "https://youtube.com/example/t-drill-basketball",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "i2D9owWYPLVr8PqIFTSN",
    "name": "Hesitation & Attack (Zwód zatrzymania)",
    "description": "Prowadzenie piłki z mocnym zwolnieniem tempa (hesitation/pogrzebanie) i wyprostowaniem sylwetki a następnie gwałtowny odjazd i atak na kosz.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example/hesi-dribble",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 278000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "import-001-stacjonarny-drybling-dwiema-pi-kami-rownoczesnie",
    "name": "Stacjonarny drybling dwiema piłkami równocześnie",
    "description": "Zawodnik stoi w postawie koszykarskiej i kozłuje dwiema piłkami jednocześnie na wysokości kolan. Nacisk na mocne uderzanie piłki o parkiet i uniezależnienie wzroku od piłki.",
    "category": "Drybling",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 30,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357363,
      "_nanoseconds": 280000000
    },
    "updatedAt": {
      "_seconds": 1785357363,
      "_nanoseconds": 280000000
    }
  },
  {
    "id": "import-002-stacjonarny-drybling-dwiema-pi-kami-naprzemiennie",
    "name": "Stacjonarny drybling dwiema piłkami naprzemiennie",
    "description": "Zawodnik kozłuje dwiema piłkami naprzemiennie (gdy jedna spada, druga unosi się). Praca nad rytmem, koordynacją i kontrolą nad obiema dłońmi.",
    "category": "Drybling",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 30,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357363,
      "_nanoseconds": 679000000
    },
    "updatedAt": {
      "_seconds": 1785357363,
      "_nanoseconds": 679000000
    }
  },
  {
    "id": "import-003-pistolet-in-and-out-z-dwiema-pi-kami",
    "name": "Pistolet / In-and-out z dwiema piłkami",
    "description": "Ruch in-and-out prawą ręką przy jednoczesnym stałym kozłowaniu lewą ręką w miejscu. Zmiana stron po ukończeniu serii.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357363,
      "_nanoseconds": 828000000
    },
    "updatedAt": {
      "_seconds": 1785357363,
      "_nanoseconds": 828000000
    }
  },
  {
    "id": "import-004-osemka-woko-nog-bez-koz-a-i-z-koz-em",
    "name": "Ósemka wokół nóg bez kozła i z kozłem",
    "description": "Zawodnik przekłada piłkę w kształcie cyfry 8 wokół nóg – najpierw bez kozła dla czucia piłki, następnie nisko kozłując przy podłodze.",
    "category": "Drybling",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357363,
      "_nanoseconds": 992000000
    },
    "updatedAt": {
      "_seconds": 1785357363,
      "_nanoseconds": 992000000
    }
  },
  {
    "id": "import-005-zwyk-a-zmiana-przed-soba-crossover",
    "name": "Zwykła zmiana przed sobą (Crossover)",
    "description": "Dynamiczny kozioł ze zmiany ręki przed korpusem z obniżeniem bioder i akcentem na mocne odepchnięcie z nogi przeciwnej.",
    "category": "Drybling",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 127000000
    },
    "updatedAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 127000000
    }
  },
  {
    "id": "import-006-zmiana-pod-noga-between-the-legs",
    "name": "Zmiana pod nogą (Between the legs)",
    "description": "Krok do przodu i przełożenie piłki nisko pod udem z dynamicznym przeniesieniem ciężaru ciała.",
    "category": "Drybling",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 218000000
    },
    "updatedAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 218000000
    }
  },
  {
    "id": "import-007-zmiana-za-plecami-behind-the-back",
    "name": "Zmiana za plecami (Behind the back)",
    "description": "Przełożenie piłki za plecami poniżej pośladków z jednoczesnym wyjściem barkiem w kierunku ataku.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 333000000
    },
    "updatedAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 333000000
    }
  },
  {
    "id": "import-008-zwrot-spin-move",
    "name": "Zwrot (Spin move)",
    "description": "Dynamiczny obrót na nogi zakrocznej z zabezpieczeniem piłki ciałem i przełożeniem jej do drugiej ręki.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 481000000
    },
    "updatedAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 481000000
    }
  },
  {
    "id": "import-009-in-and-out-z-atakiem-do-kosza",
    "name": "In-and-Out z atakiem do kosza",
    "description": "Mylący ruch dłonią nad piłką udający zmianę kierunku, po czym dynamiczne przyspieszenie tą samą stroną.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 588000000
    },
    "updatedAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 588000000
    }
  },
  {
    "id": "import-010-hesitation-wahniecie-zatrzymanie",
    "name": "Hesitation (Wahnięcie / Zatrzymanie)",
    "description": "Zwolnienie tempa kozła, wyprostowanie sylwetki udające rzut lub podanie, a następnie gwałtowny atak na nogi obrońcy.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 682000000
    },
    "updatedAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 682000000
    }
  },
  {
    "id": "import-011-shammgod-move",
    "name": "Shammgod Move",
    "description": "Wypchnięcie piłki jedną ręką w stronę obrońcy i szybkie jej zgarnięcie drugą dłonią po przekątnej z jednoczesnym zmianą tempa.",
    "category": "Drybling",
    "difficulty": "Trudne",
    "duration": 12,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 791000000
    },
    "updatedAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 791000000
    }
  },
  {
    "id": "import-012-pocket-dribble-kozio-do-kieszeni",
    "name": "Pocket Dribble (Kozioł do kieszeni)",
    "description": "Ciągnięcie piłki do tylnej kieszeni biodra przy obronie przed presją obrońcy, połączone z kontrolą odległości.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 8,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 964000000
    },
    "updatedAt": {
      "_seconds": 1785357364,
      "_nanoseconds": 964000000
    }
  },
  {
    "id": "import-013-slalom-miedzy-pacho-kami-z-podwojna-zmiana",
    "name": "Slalom między pachołkami z podwójną zmianą",
    "description": "Bieg po slalomie: przy każdym pachołku wykonanie sekwencji crossover + pod nogą i przyspieszenie do kolejnego stożka.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 62000000
    },
    "updatedAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 62000000
    }
  },
  {
    "id": "import-014-drybling-z-opaskami-na-oczy-okularami-ograniczajacymi-widocznosc",
    "name": "Drybling z opaskami na oczy / okularami ograniczającymi widoczność",
    "description": "Wykonywanie dowolnych zmian kozła w okularach odcinających dolne pole widzenia, co wymusza patrzenie na boisko.",
    "category": "Drybling",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 168000000
    },
    "updatedAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 168000000
    }
  },
  {
    "id": "import-015-drybling-z-reakcja-na-sygna-trenera",
    "name": "Drybling z reakcją na sygnał trenera",
    "description": "Zawodnik kozłuje w miejscu, na sygnał wizualny (pokazana cyfra) lub dźwiękowy wykonuje określoną zmianę i zryw na 3 metry.",
    "category": "Drybling",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 265000000
    },
    "updatedAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 265000000
    }
  },
  {
    "id": "import-016-koz-owanie-pi-ki-tenisowej-i-koszykowej",
    "name": "Kozłowanie piłki tenisowej i koszykowej",
    "description": "Kozłowanie piłki koszykowej jedną ręką przy jednoczesnym podrzucaniu i chwytaniu piłeczki tenisowej drugą ręką.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 357000000
    },
    "updatedAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 357000000
    }
  },
  {
    "id": "import-017-drybling-pod-presja-na-ma-ym-obszarze-ko-o-srodkowe",
    "name": "Drybling pod presją na małym obszarze (Koło środkowe)",
    "description": "3-4 zawodników kozłuje w kole środkowym i próbuje wybić piłkę rywalom, utrzymując własny kozioł.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 5,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 534000000
    },
    "updatedAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 534000000
    }
  },
  {
    "id": "import-018-kozio-atakujacy-z-cieniem-obroncy",
    "name": "Kozioł atakujący z cieniem obrońcy",
    "description": "Atak kozłem na dystansie całego boiska, gdzie obrońca porusza się krokiem odstawno-dostawnym bez zabierania piłki, nakładając presję.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 633000000
    },
    "updatedAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 633000000
    }
  },
  {
    "id": "import-019-kombinacja-3-zmian-crossover-under-behind",
    "name": "Kombinacja 3 zmian (Crossover + Under + Behind)",
    "description": "Płynne wykonanie w miejscu bez przerwy trzech zmian: przed sobą, pod nogą, za plecami i zryw w kierunku kosza.",
    "category": "Drybling",
    "difficulty": "Trudne",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 733000000
    },
    "updatedAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 733000000
    }
  },
  {
    "id": "import-020-drop-split-foot-dribble",
    "name": "Drop Split Foot Dribble",
    "description": "Lądowanie w szerokim rozroku (drop) z jednoczesnym schowaniem piłki i gotowością do wyjścia w dowolną stronę.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 8,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 829000000
    },
    "updatedAt": {
      "_seconds": 1785357365,
      "_nanoseconds": 829000000
    }
  },
  {
    "id": "import-021-wrap-around-ominiecie-za-plecami-po-kozle",
    "name": "Wrap-around (Ominięcie za plecami po kozle)",
    "description": "Dynamiczne przełożenie piłki za plecami długim ruchem omijającym obrońcę w pełnym biegu.",
    "category": "Drybling",
    "difficulty": "Trudne",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 16000000
    },
    "updatedAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 16000000
    }
  },
  {
    "id": "import-022-koz-owanie-z-guma-oporowa-woko-nog",
    "name": "Kozłowanie z gumą oporową wokół nóg",
    "description": "Kozłowanie w niskiej postawie z gumą mini-band nad kolanami, budujące siłę nóg i stabilizację bioder.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 113000000
    },
    "updatedAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 113000000
    }
  },
  {
    "id": "import-023-przenoszenie-ciezaru-cia-a-z-koz-em-shiftiness-drill",
    "name": "Przenoszenie ciężaru ciała z kozłem (Shiftiness Drill)",
    "description": "Kozłowanie boczno-skośne z wyraźnym bujaniem bioder i odpychaniem się z krawędzi stóp w celu zgubienia obrońcy.",
    "category": "Drybling",
    "difficulty": "Trudne",
    "duration": 12,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 207000000
    },
    "updatedAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 207000000
    }
  },
  {
    "id": "import-024-retreat-dribble-kozio-wycofujacy",
    "name": "Retreat Dribble (Kozioł wycofujący)",
    "description": "Dwa kozły dynamiczne w tył po zatrzymaniu, z osłoną piłki barkiem i głową w górze w celu wyjścia spod podwojenia.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 309000000
    },
    "updatedAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 309000000
    }
  },
  {
    "id": "import-025-atak-linii-koncowej-z-koz-em-kontrolnym-baseline-push",
    "name": "Atak linii końcowej z kozłem kontrolnym (Baseline Push)",
    "description": "Kozłowanie wzdłuż linii końcowej pod kątem z unikaniem wyjścia za boisko i nagłą zmianą kierunku do środka.",
    "category": "Drybling",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 405000000
    },
    "updatedAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 405000000
    }
  },
  {
    "id": "import-026-podania-oburacz-z-klatki-piersiowej-w-dwojkach",
    "name": "Podania oburącz z klatki piersiowej w dwójkach",
    "description": "Podstawowe podanie bez kozła na wysokości klatki piersiowej. Nacisk na wyprost rąk, skręcenie nadgarstków na zewnątrz i krok w stronę partnera.",
    "category": "Podania",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 578000000
    },
    "updatedAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 578000000
    }
  },
  {
    "id": "import-027-podania-z-koz-em-bounce-pass",
    "name": "Podania z kozłem (Bounce pass)",
    "description": "Podanie z odbiciem piłki o parkiet w 2/3 odległości do partnera. Ważne obniżenie pozycji i wyjście spod rąk obrońcy.",
    "category": "Podania",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 668000000
    },
    "updatedAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 668000000
    }
  },
  {
    "id": "import-028-podania-jednoracz-znad-barku-baseball-pass",
    "name": "Podania jednorącz znad barku (Baseball pass)",
    "description": "Długie podanie na cały krok wybiegającego partnera w szybkim ataku z wykorzystaniem rotacji tułowia.",
    "category": "Podania",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 763000000
    },
    "updatedAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 763000000
    }
  },
  {
    "id": "import-029-podania-znad-g-owy-overhead-pass",
    "name": "Podania znad głowy (Overhead pass)",
    "description": "Podanie dwoma rękami sponad głowy nad rękami obrońcy, idealne do skrzydeł lub pod kosz do wysokiego.",
    "category": "Podania",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 854000000
    },
    "updatedAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 854000000
    }
  },
  {
    "id": "import-030-podania-znad-g-owy-z-koz-em-overhead-bounce-pass",
    "name": "Podania znad głowy z kozłem (Overhead bounce pass)",
    "description": "Dynamiczne podanie po kozle znad głowy stosowane przeciwko strefie lub przy agresywnej obronie.",
    "category": "Podania",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 954000000
    },
    "updatedAt": {
      "_seconds": 1785357366,
      "_nanoseconds": 954000000
    }
  },
  {
    "id": "import-031-podania-jednoracz-z-koz-a-push-pass",
    "name": "Podania jednorącz z kozła (Push pass)",
    "description": "Szybkie wypchnięcie piłki jedną ręką bezpośrednio z kozła bez zbierania piłki w drugą dłoń.",
    "category": "Podania",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 106000000
    },
    "updatedAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 106000000
    }
  },
  {
    "id": "import-032-podanie-hook-pass-hakiem",
    "name": "Podanie Hook Pass (Hakiem)",
    "description": "Podanie jednorącz nad obrońcą ruchem hakowym podczas mijania lub obrotu.",
    "category": "Podania",
    "difficulty": "Trudne",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 197000000
    },
    "updatedAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 197000000
    }
  },
  {
    "id": "import-033-podanie-pocket-pass-do-kieszeni-przy-pick-roll",
    "name": "Podanie Pocket Pass (Do kieszeni przy Pick&Roll)",
    "description": "Krótkie, szybkie podanie z kozłem wciskane pod rękami obrońcy do rolowanego gracza wysokiego.",
    "category": "Podania",
    "difficulty": "Trudne",
    "duration": 12,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 296000000
    },
    "updatedAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 296000000
    }
  },
  {
    "id": "import-034-podanie-skip-pass-na-s-aba-strone",
    "name": "Podanie Skip Pass (Na słabą stronę)",
    "description": "Długie, silne podanie sponad głowy lub z pętli nad obroną na przeciwległą obwódkę do czystego strzelca.",
    "category": "Podania",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 396000000
    },
    "updatedAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 396000000
    }
  },
  {
    "id": "import-035-podanie-po-zwodzie-podania-pass-fake-pass",
    "name": "Podanie po zwodzie podania (Pass fake pass)",
    "description": "Markowanie podania w jedną stronę i natychmiastowa zmiana decyzji oraz podanie w przeciwną kierunku.",
    "category": "Podania",
    "difficulty": "Średnie",
    "duration": 8,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 485000000
    },
    "updatedAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 485000000
    }
  },
  {
    "id": "import-036-podania-w-trojkach-po-przeplatance-weave-3-man",
    "name": "Podania w trójkach po przeplatańce (Weave 3-man)",
    "description": "Bieg trzech zawodników przez całe boisko, gdzie po każdym podaniu zawodnik przebiega za plecami adresata podania.",
    "category": "Podania",
    "difficulty": "Łatwe",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 628000000
    },
    "updatedAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 628000000
    }
  },
  {
    "id": "import-037-podania-w-czworkach-z-dwoma-pi-kami",
    "name": "Podania w czwórkach z dwoma piłkami",
    "description": "Zawodnicy stoją w kwadracie i podają dwie piłki jednocześnie (jedna górą, druga z kozłem) wymuszając skupienie.",
    "category": "Podania",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 718000000
    },
    "updatedAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 718000000
    }
  },
  {
    "id": "import-038-podania-w-marszu-biegu-w-dwojkach",
    "name": "Podania w marszu/biegu w dwójkach",
    "description": "Dwóch zawodników przemieszcza się równolegle wzdłuż boiska wykonując podania bez zatrzymywania biegu.",
    "category": "Podania",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 809000000
    },
    "updatedAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 809000000
    }
  },
  {
    "id": "import-039-podanie-wrap-around-ominiecie-obroncy-d-onia",
    "name": "Podanie Wrap-around (Ominięcie obrońcy dłonią)",
    "description": "Podanie dolne obok biodra obrońcy po zamarkowaniu wejścia na kosz.",
    "category": "Podania",
    "difficulty": "Trudne",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 898000000
    },
    "updatedAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 898000000
    }
  },
  {
    "id": "import-040-gra-w-dziadka-podania-w-kole-przeciw-obroncy",
    "name": "Gra w dziadka / Podania w kole przeciw obrońcy",
    "description": "4 zawodników na obwodzie koła podaje między sobą, a 1 obrońca w środku próbuje przejąć piłkę. Ograniczony czas podania.",
    "category": "Podania",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 989000000
    },
    "updatedAt": {
      "_seconds": 1785357367,
      "_nanoseconds": 989000000
    }
  },
  {
    "id": "import-041-podania-ze-skoku-jump-pass-z-decyzja",
    "name": "Podania ze skoku (Jump pass) z decyzją",
    "description": "Zawodnik wyskakuje w powietrze udając rzut i podejmuje decyzję o podaniu do wolnego partnera przed wylądowaniem.",
    "category": "Podania",
    "difficulty": "Trudne",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 157000000
    },
    "updatedAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 157000000
    }
  },
  {
    "id": "import-042-podanie-z-pod-ogi-po-zbiorce-outlet-pass",
    "name": "Podanie z podłogi po zbiórce (Outlet pass)",
    "description": "Zbierający po chwycie w powietrzu ląduje i natychmiast wykonuje zdecydowane podanie otworu do rozgrywającego.",
    "category": "Podania",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 251000000
    },
    "updatedAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 251000000
    }
  },
  {
    "id": "import-043-podania-w-parach-pod-presja-pasywna-obroncy",
    "name": "Podania w parach pod presją pasywną obrońcy",
    "description": "Podający musi wykonać zwód rękami i podać obok aktywnie pracującego ramionami obrońcy.",
    "category": "Podania",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 345000000
    },
    "updatedAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 345000000
    }
  },
  {
    "id": "import-044-d-ugie-podanie-po-przekatnej-na-dobieg",
    "name": "Długie podanie po przekątnej na dobieg",
    "description": "Podanie ze skrajnej linii na wysuniętego partnera w pełnym biegu z idealnym wyczuciem tempa.",
    "category": "Podania",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 441000000
    },
    "updatedAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 441000000
    }
  },
  {
    "id": "import-045-kaskada-podan-pod-kosz-z-wyjsciem-na-zas-one",
    "name": "Kaskada podań pod kosz z wyjściem na zasłonę",
    "description": "Złożona sekwencja 4 podań obwodowych zakończona ścinaniem pod kosz z do podania w tempo.",
    "category": "Podania",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 532000000
    },
    "updatedAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 532000000
    }
  },
  {
    "id": "import-046-dwutakt-prawa-i-lewa-reka-layup",
    "name": "Dwutakt prawą i lewą ręką (Layup)",
    "description": "Podstawowe wykończenie z dobiegu na dwie tempo, noga przeciwna od ręki rzucającej w górę, rzut o tablicę.",
    "category": "Rzuty",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 686000000
    },
    "updatedAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 686000000
    }
  },
  {
    "id": "import-047-dwutakt-z-dwutaktu-wstecznego-reverse-layup",
    "name": "Dwutakt z dwutaktu wstecznego (Reverse Layup)",
    "description": "Wykończenie pod koszem po drugiej stronie obręczy z wykorzystaniem tablicy jako ochrony przed blokiem.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 775000000
    },
    "updatedAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 775000000
    }
  },
  {
    "id": "import-048-dwutakt-z-krokiem-w-bok-eurostep",
    "name": "Dwutakt z krokiem w bok (Eurostep)",
    "description": "Mylący krok w jedną stronę w celu wymuszenia reakcji obrońcy i natychmiastowy sus sus w drugą stronę zakończony rzutem.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 867000000
    },
    "updatedAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 867000000
    }
  },
  {
    "id": "import-049-float-floater-ezka",
    "name": "Float (Floater / Łezka)",
    "description": "Miękki rzut wysoką trajektorią z jednej lub dwóch nóg przed nadbiegającym wysokim obrońcą.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 970000000
    },
    "updatedAt": {
      "_seconds": 1785357368,
      "_nanoseconds": 970000000
    }
  },
  {
    "id": "import-050-rzut-z-wyskoku-stacjonarny-catch-and-shoot",
    "name": "Rzut z wyskoku stacjonarny (Catch and Shoot)",
    "description": "Rzut po chwycie piłki od partnera z szybkim ułożeniem stóp i płynnym ruchem wykończeniowym.",
    "category": "Rzuty",
    "difficulty": "Łatwe",
    "duration": 12,
    "repetitions": 25,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 62000000
    },
    "updatedAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 62000000
    }
  },
  {
    "id": "import-051-rzut-po-kozle-pull-up-jumper",
    "name": "Rzut po kozle (Pull-up jumper)",
    "description": "Dynamiczne zatrzymanie z kozła (na dwa tempa lub naskok) i natychmiastowy rzut z wyskoku.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 203000000
    },
    "updatedAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 203000000
    }
  },
  {
    "id": "import-052-rzuty-osobiste-pod-zmeczeniem",
    "name": "Rzuty osobiste pod zmęczeniem",
    "description": "Wykonanie serii 2 rzutów wolnych po intensywnym sprincie przez całe boisko.",
    "category": "Rzuty",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 293000000
    },
    "updatedAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 293000000
    }
  },
  {
    "id": "import-053-rzuty-po-zas-onie-na-pi-ce-pick-pop-roll",
    "name": "Rzuty po zasłonie na piłce (Pick & Pop / Roll)",
    "description": "Rzut z półdystansu lub dystansu po odebraniu podania od gracza kozłującego z zasłony.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 390000000
    },
    "updatedAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 390000000
    }
  },
  {
    "id": "import-054-rzuty-z-5-pozycji-obwodowych-around-the-world",
    "name": "Rzuty z 5 pozycji obwodowych (Around the World)",
    "description": "Seria rzutów za 3 punkty lub półdystansu z 5 stałych miejsc wokół trumny.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 15,
    "repetitions": 25,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 485000000
    },
    "updatedAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 485000000
    }
  },
  {
    "id": "import-055-rzut-z-odchylenia-fadeaway",
    "name": "Rzut z odchylenia (Fadeaway)",
    "description": "Rzut z wyskoku ze skłonem tułowia w tył dla stworzenia przestrzeni od bloku obrońcy.",
    "category": "Rzuty",
    "difficulty": "Trudne",
    "duration": 12,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 576000000
    },
    "updatedAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 576000000
    }
  },
  {
    "id": "import-056-rzut-hakiem-hook-shot-skyhook",
    "name": "Rzut Hakiem (Hook Shot / Skyhook)",
    "description": "Rzut jednorącz bokiem do kosza z wysokim uniesieniem ramienia i osłoną drugą ręką.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 724000000
    },
    "updatedAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 724000000
    }
  },
  {
    "id": "import-057-mikan-drill-wykonczenie-spod-kosza-raz-za-razem",
    "name": "Mikan Drill (Wykończenie spod kosza raz za razem)",
    "description": "Dynamiczne rzuty spod samego kosza raz prawą, raz lewą ręką bez opuszczania piłki poniżej klatki.",
    "category": "Rzuty",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 30,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 813000000
    },
    "updatedAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 813000000
    }
  },
  {
    "id": "import-058-reverse-mikan-drill",
    "name": "Reverse Mikan Drill",
    "description": "Rzuty spod kosza tyłem do deski raz z prawej, raz z lewej strony z ciągłą zbiórką w powietrzu.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 8,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 908000000
    },
    "updatedAt": {
      "_seconds": 1785357369,
      "_nanoseconds": 908000000
    }
  },
  {
    "id": "import-059-step-back-jumper-rzut-po-kroku-w-ty",
    "name": "Step-back Jumper (Rzut po kroku w tył)",
    "description": "Odepchnięcie się z nogi zakrocznej po kozle, zrobienie przestrzeni krok tył i szybki rzut.",
    "category": "Rzuty",
    "difficulty": "Trudne",
    "duration": 12,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 5000000
    },
    "updatedAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 5000000
    }
  },
  {
    "id": "import-060-side-step-jumper-rzut-po-kroku-w-bok",
    "name": "Side-step Jumper (Rzut po kroku w bok)",
    "description": "Wykonanie dynamicznego odskoku w bok po kozle dla ucieczki od obrońcy na obwodzie.",
    "category": "Rzuty",
    "difficulty": "Trudne",
    "duration": 12,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 99000000
    },
    "updatedAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 99000000
    }
  },
  {
    "id": "import-061-up-and-under-zwod-rzutu-i-wykonczenie-pod-reka",
    "name": "Up and Under (Zwód rzutu i wykończenie pod ręką)",
    "description": "Mocne zamarkowanie rzutu w postacie tyłem, wymuszenie skoku obrońcy i krok pod nim na rzut.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 259000000
    },
    "updatedAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 259000000
    }
  },
  {
    "id": "import-062-power-layup-wykonczenie-z-dwoch-nog-z-kontaktem",
    "name": "Power Layup (Wykończenie z dwóch nóg z kontaktem)",
    "description": "Naskok na dwie nogi pod koszem, twarde utrzymać pozycję z kontaktem fizycznym i wykończenie górą.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 360000000
    },
    "updatedAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 360000000
    }
  },
  {
    "id": "import-063-rzuty-ze-scinania-po-linii-koncowej-baseline-cut",
    "name": "Rzuty ze ścinania po linii końcowej (Baseline Cut)",
    "description": "Ścinanie ze słabej strony wzdłuż linii końcowej, chwyt podania i natychmiastowe wykończenie.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 10.15,
    "repetitions": 0,
    "youtubeUrl": "",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 453000000
    },
    "updatedAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 453000000
    }
  },
  {
    "id": "import-064-rzut-po-wyjsciu-ze-stosu-zas-on-screen-exit",
    "name": "Rzut po wyjściu ze stosu zasłon (Screen Exit)",
    "description": "Sprint po zasłonie podwójnej na obwód, zbiegnięcie w tempo i rzut po złapaniu.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 547000000
    },
    "updatedAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 547000000
    }
  },
  {
    "id": "import-065-rzuty-pod-presja-czasu-beat-the-clock",
    "name": "Rzuty pod presją czasu (Beat the Clock)",
    "description": "Rzut wykonany w ciągu 3 sekund od otrzymania piłki z głośnym odliczaniem zespołu.",
    "category": "Rzuty",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 729000000
    },
    "updatedAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 729000000
    }
  },
  {
    "id": "import-066-rzut-po-zbiorce-w-powietrzu-tip-in-putback",
    "name": "Rzut po zbiórce w powietrzu (Tip-in / Putback)",
    "description": "Dojście do zbiórki ofensywnej i ponowienie rzutu bezpośrednio z powietrza lub po 1 naskoku.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 845000000
    },
    "updatedAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 845000000
    }
  },
  {
    "id": "import-067-rzut-z-rogu-po-wniknieciu-i-podaniu-kick-out-shot",
    "name": "Rzut z rogu po wniknięciu i podaniu (Kick-out Shot)",
    "description": "Kozłujący wnika w trumnę, ściąga obronę i odgrywa do rogu na czysty rzut trzypunktowy.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 947000000
    },
    "updatedAt": {
      "_seconds": 1785357370,
      "_nanoseconds": 947000000
    }
  },
  {
    "id": "import-068-wykonczenie-floaterem-z-jednej-nogi-po-obrocie",
    "name": "Wykończenie floaterem z jednej nogi po obrocie",
    "description": "Obrót w trumnie i wyrzut piłki jednorącz na wysokim łuku przed spóźnioną pomocą.",
    "category": "Rzuty",
    "difficulty": "Trudne",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 50000000
    },
    "updatedAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 50000000
    }
  },
  {
    "id": "import-069-rzuty-po-sprincie-z-kontry-transition-jumper",
    "name": "Rzuty po sprincie z kontry (Transition Jumper)",
    "description": "Przybiegnięcie z drugiego końca boiska, zatrzymanie na linii 3 punktów i pewny rzut.",
    "category": "Rzuty",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 146000000
    },
    "updatedAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 146000000
    }
  },
  {
    "id": "import-070-konkurs-rzutowy-33-lub-knockout",
    "name": "Konkurs rzutowy '33' lub 'Knockout'",
    "description": "Rywalizacja grupowa w rzutach z dystansu i dobitkach budująca odporność psychiczną.",
    "category": "Rzuty",
    "difficulty": "Łatwe",
    "duration": 15,
    "repetitions": 5,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 302000000
    },
    "updatedAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 302000000
    }
  },
  {
    "id": "import-071-krok-odstawno-dostawny-w-postawie-obronnej",
    "name": "Krok odstawno-dostawny w postawie obronnej",
    "description": "Poruszanie się w niskiej pozycji obronnej bez krzyżowania nóg, klatka piersiowa wypchnięta, ręce aktywne.",
    "category": "Obrona",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 396000000
    },
    "updatedAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 396000000
    }
  },
  {
    "id": "import-072-praca-nog-w-obronie-na-ca-ym-boisku-zig-zag-drill",
    "name": "Praca nóg w obronie na całym boisku (Zig-Zag Drill)",
    "description": "Poruszanie się obrońcy krok odstawno-dostawnym od linii bocznej do środka po linii zygzaka za kozłującym.",
    "category": "Obrona",
    "difficulty": "Łatwe",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 507000000
    },
    "updatedAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 507000000
    }
  },
  {
    "id": "import-073-closeout-doskok-do-strzelca-na-obwodzie",
    "name": "Closeout (Doskok do strzelca na obwodzie)",
    "description": "Szybki podbieg do rywala otrzymującego piłkę, zwolnienie na ostatnich krokach małymi krokami i uniesienie ręki.",
    "category": "Obrona",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 601000000
    },
    "updatedAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 601000000
    }
  },
  {
    "id": "import-074-obrona-gracza-bez-pi-ki-deny-position-odciecie",
    "name": "Obrona gracza bez piłki (Deny position / Odcięcie)",
    "description": "Ustawienie z ręką i nogą w linii podania do zawodnika atakującego, uniemożliwiające łatwe podanie.",
    "category": "Obrona",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 781000000
    },
    "updatedAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 781000000
    }
  },
  {
    "id": "import-075-obrona-pozycji-pomocy-help-and-recover",
    "name": "Obrona pozycji pomocy (Help and Recover)",
    "description": "Zejście z krycia swojego gracza w stronę trumny na linię pomocy i szybki powrót po podaniu.",
    "category": "Obrona",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 873000000
    },
    "updatedAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 873000000
    }
  },
  {
    "id": "import-076-obrona-pick-roll-przejscie-gora-over",
    "name": "Obrona Pick & Roll - Przejście górą (Over)",
    "description": "Obrońca gracza z piłką walczy o przejście nad zasłoną, nie dając czystej pozycji do rzutu.",
    "category": "Obrona",
    "difficulty": "Trudne",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 971000000
    },
    "updatedAt": {
      "_seconds": 1785357371,
      "_nanoseconds": 971000000
    }
  },
  {
    "id": "import-077-obrona-pick-roll-przejscie-do-em-under",
    "name": "Obrona Pick & Roll - Przejście dołem (Under)",
    "description": "Obrońca przechodzi pod zasłoną unikając starcia, dając przestrzeń rzutową słabszemu strzelcowi.",
    "category": "Obrona",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 61000000
    },
    "updatedAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 61000000
    }
  },
  {
    "id": "import-078-obrona-pick-roll-drop-coverage",
    "name": "Obrona Pick & Roll - Drop Coverage",
    "description": "Obrońca zasłaniającego cofa się głęboko w trumnę chroniąc kosz, podczas gdy obrońca piłki goni rywala.",
    "category": "Obrona",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 156000000
    },
    "updatedAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 156000000
    }
  },
  {
    "id": "import-079-obrona-pick-roll-podwojenie-trap-blitz",
    "name": "Obrona Pick & Roll - Podwojenie (Trap / Blitz)",
    "description": "Obaj obrońcy agresywnie doskakują do kozłującego po zasłonie, zmuszając go do oddania piłki.",
    "category": "Obrona",
    "difficulty": "Trudne",
    "duration": 12,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 305000000
    },
    "updatedAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 305000000
    }
  },
  {
    "id": "import-080-wymuszenie-b-edu-szarzy-taking-a-charge",
    "name": "Wymuszenie błędu szarży (Taking a charge)",
    "description": "Szybkie zajęcie legalnej pozycji obronnej przed wnikającym atakującym i kontrolowany upadek po kontakcie.",
    "category": "Obrona",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 396000000
    },
    "updatedAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 396000000
    }
  },
  {
    "id": "import-081-obrona-po-przekazaniu-switching-defense",
    "name": "Obrona po przekazaniu (Switching defense)",
    "description": "Komunikacja i natychmiastowa zamiana krytych zawodników przy zasłonie na piłce lub bez piłki.",
    "category": "Obrona",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 493000000
    },
    "updatedAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 493000000
    }
  },
  {
    "id": "import-082-obrona-w-trumnie-przeciwko-graczowi-ty-em-do-kosza",
    "name": "Obrona w trumnie przeciwko graczowi tyłem do kosza",
    "description": "Praca ciałem i przedramieniem na biodrze rywala postawionego w pozie tyłem, bez wyciągania rąk do faulu.",
    "category": "Obrona",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 582000000
    },
    "updatedAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 582000000
    }
  },
  {
    "id": "import-083-obrona-linii-koncowej-baseline-help-rotation",
    "name": "Obrona linii końcowej (Baseline help rotation)",
    "description": "Rotacja obrońcy ze słabej strony do pomocy przy wniknięciu rywala wzdłuż linii końcowej.",
    "category": "Obrona",
    "difficulty": "Trudne",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 672000000
    },
    "updatedAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 672000000
    }
  },
  {
    "id": "import-084-kradziez-pi-ki-z-koz-a-ball-swipe-digging",
    "name": "Kradzież piłki z kozła (Ball swipe / Digging)",
    "description": "Wytrącenie piłki nisko wyciągniętą dłonią od dołu podczas kozła rywala na obwodzie.",
    "category": "Obrona",
    "difficulty": "Średnie",
    "duration": 8,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 830000000
    },
    "updatedAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 830000000
    }
  },
  {
    "id": "import-085-obrona-na-pe-nym-boisku-full-court-press-individual",
    "name": "Obrona na pełnym boisku (Full-court Press Individual)",
    "description": "Presja na graczu z piłką na całej długości boiska w celu opóźnienia rozegrania akcji.",
    "category": "Obrona",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 931000000
    },
    "updatedAt": {
      "_seconds": 1785357372,
      "_nanoseconds": 931000000
    }
  },
  {
    "id": "import-086-boksowanie-i-zastawianie-w-obronie-box-out",
    "name": "Boksowanie i zastawianie w obronie (Box out)",
    "description": "Wykonanie kontaktu ciałem z rywalem po rzucie, obrócenie się tyłem i wychnięcie go od kosza.",
    "category": "Obrona",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 50000000
    },
    "updatedAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 50000000
    }
  },
  {
    "id": "import-087-obrona-strefowa-2-3-podstawowe-przemieszczenia",
    "name": "Obrona strefowa 2-3 (Podstawowe przemieszczenia)",
    "description": "Synchronizacja ruchów 5 zawodników w strefie 2-3 w zależności od pozycji piłki na obwodzie.",
    "category": "Obrona",
    "difficulty": "Średnie",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 138000000
    },
    "updatedAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 138000000
    }
  },
  {
    "id": "import-088-obrona-strefowa-1-3-1-pu-apki-w-naroznikach",
    "name": "Obrona strefowa 1-3-1 (Pułapki w narożnikach)",
    "description": "Przesuwanie się w strefie 1-3-1 z nakładaniem podwojenia na piłce w narożnikach boiska.",
    "category": "Obrona",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 237000000
    },
    "updatedAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 237000000
    }
  },
  {
    "id": "import-089-opcja-odbudowy-pozycji-po-powrocie-recovery-sprint",
    "name": "Opcja odbudowy pozycji po powrocie (Recovery Sprint)",
    "description": "Sprint po spóźnieniu i zablokowanie rzutu z tyłu lub zamknięcie kąta natarcia.",
    "category": "Obrona",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 397000000
    },
    "updatedAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 397000000
    }
  },
  {
    "id": "import-090-komunikacja-w-obronie-g-osne-nawo-ywanie",
    "name": "Komunikacja w obronie (Głośne nawoływanie)",
    "description": "Ćwiczenie obronne ukierunkowane na głośne wywoływanie zasłon, pomocy i przejęć przez graczy.",
    "category": "Obrona",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 488000000
    },
    "updatedAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 488000000
    }
  },
  {
    "id": "import-091-gra-1-na-1-z-ograniczeniem-do-3-koz-ow",
    "name": "Gra 1 na 1 z ograniczeniem do 3 kozłów",
    "description": "Pojedynek 1v1 z obwodu. Atakujący ma maksymalnie 3 kozły na wykończenie akcji rzutem.",
    "category": "Taktyka",
    "difficulty": "Łatwe",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 585000000
    },
    "updatedAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 585000000
    }
  },
  {
    "id": "import-092-gra-2-na-2-z-zas-ona-bezposrednia-pick-roll",
    "name": "Gra 2 na 2 z zasłoną bezpośrednią (Pick & Roll)",
    "description": "Ćwiczenie współpracy dwóch zawodników z wykorzystaniem zasłony i czytaniem obrony.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 15,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 677000000
    },
    "updatedAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 677000000
    }
  },
  {
    "id": "import-093-gra-2-na-2-z-zas-ona-bez-pi-ki-off-ball-screen",
    "name": "Gra 2 na 2 z zasłoną bez piłki (Off-ball Screen)",
    "description": "Stawianie zasłony dla gracza bez piłki i wyjście na czystą pozycję rzutową.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 15,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 769000000
    },
    "updatedAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 769000000
    }
  },
  {
    "id": "import-094-gra-3-na-3-na-jeden-kosz-half-court-3v3",
    "name": "Gra 3 na 3 na jeden kosz (Half-court 3v3)",
    "description": "Standardowa gra w ograniczonej przestrzeni wymuszająca szybkie podejmowanie decyzji i ruch.",
    "category": "Taktyka",
    "difficulty": "Łatwe",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 924000000
    },
    "updatedAt": {
      "_seconds": 1785357373,
      "_nanoseconds": 924000000
    }
  },
  {
    "id": "import-095-atak-typu-motion-wniknij-i-oddaj-drive-kick",
    "name": "Atak typu Motion - Wniknij i oddaj (Drive & Kick)",
    "description": "Mijanie pierwszego obrońcy, odgrywanie piłki na obwód do wolnego partnera i ponowienie ruchu.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 23000000
    },
    "updatedAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 23000000
    }
  },
  {
    "id": "import-096-atak-give-and-go-podaj-i-scinaj",
    "name": "Atak Give and Go (Podaj i ścinaj)",
    "description": "Podanie na obwód i natychmiastowe dynamiczne ścinanie pod kosz po podanie zwrotne.",
    "category": "Taktyka",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 117000000
    },
    "updatedAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 117000000
    }
  },
  {
    "id": "import-097-atak-strefowy-podanie-do-srodka-high-post-flash",
    "name": "Atak strefowy - Podanie do środka (High Post Flash)",
    "description": "Wejście gracza wysokiego na linię rzutów wolnych w celu rozbicia obrony strefowej.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 209000000
    },
    "updatedAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 209000000
    }
  },
  {
    "id": "import-098-gry-uproszczone-4-na-4-bez-koz-a",
    "name": "Gry uproszczone 4 na 4 bez kozła",
    "description": "Gra 4v4 w której atakujący mogą używać tylko podań i ruchu bez piłki. Rozwija podania i ścinanie.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 15,
    "repetitions": 6,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 303000000
    },
    "updatedAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 303000000
    }
  },
  {
    "id": "import-099-zagranie-horns-rogi-opcje-otwarcia",
    "name": "Zagranie Horns (Rogi) - Opcje otwarcia",
    "description": "Ustawienie taktyczne z dwoma wysokimi na rogu trumny i czytaniem reakcji obrony po zasłonie.",
    "category": "Taktyka",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 439000000
    },
    "updatedAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 439000000
    }
  },
  {
    "id": "import-100-zagranie-spain-pick-roll",
    "name": "Zagranie Spain Pick & Roll",
    "description": "Zasłona na piłce połączona z drugą zasłoną bez piłki od tyłu dla obrońca zasłaniającego.",
    "category": "Taktyka",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 530000000
    },
    "updatedAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 530000000
    }
  },
  {
    "id": "import-101-zagranie-flex-scinanie-z-linii-koncowej",
    "name": "Zagranie Flex (Ścinanie z linii końcowej)",
    "description": "Kaskadowe stawianie zasłon po przekątnej z wymuszeniem przewagi pod samym koszem.",
    "category": "Taktyka",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 621000000
    },
    "updatedAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 621000000
    }
  },
  {
    "id": "import-102-rozegranie-autu-z-linii-koncowej-ato-inbounds",
    "name": "Rozegranie autu z linii końcowej (ATO Inbounds)",
    "description": "Ustawienie w rzędzie (Stack) i rozbiegnięcie na pozycje rzutowe pod koszem lub na obwodzie.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 719000000
    },
    "updatedAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 719000000
    }
  },
  {
    "id": "import-103-rozegranie-autu-z-linii-bocznej-sideline-ato",
    "name": "Rozegranie autu z linii bocznej (Sideline ATO)",
    "description": "Taktyczny schemat autu bocznego na podanie do rzutu w ostatnich sekundach kwarty.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 814000000
    },
    "updatedAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 814000000
    }
  },
  {
    "id": "import-104-isolation-1v1-ze-skrzyd-a-z-asekuracja",
    "name": "Isolation 1v1 ze skrzydła z asekuracją",
    "description": "Atak indywidualny z boku przy zachowaniu właściwej przestrzeni (spacing) pozostałych 4 graczy.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 970000000
    },
    "updatedAt": {
      "_seconds": 1785357374,
      "_nanoseconds": 970000000
    }
  },
  {
    "id": "import-105-sprawdzanie-spacingu-struktura-5-out",
    "name": "Sprawdzanie spacingu (Struktura 5-out)",
    "description": "Atak pozycyjny z rozstawieniem 5 graczy na obwodzie i zachowaniem 4-5 metrów odstępu.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 61000000
    },
    "updatedAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 61000000
    }
  },
  {
    "id": "import-106-pojedynek-w-poscie-1v1-post-play",
    "name": "Pojedynek w poście 1v1 (Post Play)",
    "description": "Gra tyłem do kosza gracza podkoszowego z czytaniem pomocy ze słabej strony.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 152000000
    },
    "updatedAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 152000000
    }
  },
  {
    "id": "import-107-gra-4-na-3-po-podwojeniu-p-r-short-roll-4v3",
    "name": "Gra 4 na 3 po podwojeniu P&R (Short Roll 4v3)",
    "description": "Rolujący odbiera piłkę w okolicach linii rzutów wolnych i podejmuje szybką decyzję przewagi 4v3.",
    "category": "Taktyka",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 243000000
    },
    "updatedAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 243000000
    }
  },
  {
    "id": "import-108-przeciwdzia-anie-pu-apkom-obronnym-press-break",
    "name": "Przeciwdziałanie pułapkom obronnym (Press Break)",
    "description": "Ustawienie i ruch piłki przełamujący presję rywala na całym boisku.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 339000000
    },
    "updatedAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 339000000
    }
  },
  {
    "id": "import-109-atak-na-obrone-strefowa-3-2-z-rogu-corner-overload",
    "name": "Atak na obronę strefową 3-2 z rogu (Corner overload)",
    "description": "Przeciążenie jednej strony boiska w celu stworzenia wolnej pozycji w narożniku.",
    "category": "Taktyka",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 497000000
    },
    "updatedAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 497000000
    }
  },
  {
    "id": "import-110-symulacja-ostatnich-24-sekund-meczu-clutch-situations",
    "name": "Symulacja ostatnich 24 sekund meczu (Clutch Situations)",
    "description": "Gra taktyczna od wyniku remisowego z egzekucją precyzyjnego schematu pod presją czasu.",
    "category": "Taktyka",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 5,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 587000000
    },
    "updatedAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 587000000
    }
  },
  {
    "id": "import-111-szybki-atak-2-na-1-fastbreak-2v1",
    "name": "Szybki atak 2 na 1 (Fastbreak 2v1)",
    "description": "Dwóch atakujących biegnie na jednego obrońcę, czytając jego zachowanie i kończąc podaniem lub rzutem.",
    "category": "Szybki atak",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 684000000
    },
    "updatedAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 684000000
    }
  },
  {
    "id": "import-112-szybki-atak-3-na-2-fastbreak-3v2",
    "name": "Szybki atak 3 na 2 (Fastbreak 3v2)",
    "description": "Trzech atakujących rozciąga boisko (środek + skrzydła) atakując dwóch obrońców w trumnie.",
    "category": "Szybki atak",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 779000000
    },
    "updatedAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 779000000
    }
  },
  {
    "id": "import-113-przejscie-z-3v2-do-2v1-continuity-drill",
    "name": "Przejście z 3v2 do 2v1 (Continuity drill)",
    "description": "Falowy atak: trójka atakuje dwójkę, strzelec wraca do obrony, a dwójka obrońców atakuje 2v1 na drugi kosz.",
    "category": "Szybki atak",
    "difficulty": "Średnie",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 880000000
    },
    "updatedAt": {
      "_seconds": 1785357375,
      "_nanoseconds": 880000000
    }
  },
  {
    "id": "import-114-szybki-atak-po-zbiorce-i-podaniu-otwarcia-outlet-fastbreak",
    "name": "Szybki atak po zbiórce i podaniu otwarcia (Outlet Fastbreak)",
    "description": "Zbierający odgrywa do rozgrywającego, ten ścina środkiem i uruchamia skrzydłowych.",
    "category": "Szybki atak",
    "difficulty": "Łatwe",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 22000000
    },
    "updatedAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 22000000
    }
  },
  {
    "id": "import-115-szybki-atak-4-na-3-z-dobiegajacym-trailingiem",
    "name": "Szybki atak 4 na 3 z dobiegającym trailingiem",
    "description": "Kontra z przewagą liczebną zakończona podaniem w tył do nadbiegającego gracza wysokiego.",
    "category": "Szybki atak",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 117000000
    },
    "updatedAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 117000000
    }
  },
  {
    "id": "import-116-szybki-atak-1-na-0-ze-sprintem-po-ca-ym-boisku",
    "name": "Szybki atak 1 na 0 ze sprintem po całym boisku",
    "description": "Samodzielny powrót z kozłem w pełem sprincie i wykończenie dwutaktem bez zwolnienia.",
    "category": "Szybki atak",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 206000000
    },
    "updatedAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 206000000
    }
  },
  {
    "id": "import-117-szybki-atak-z-rzutem-za-3-punkty-w-pierwszym-tempie-early-offense",
    "name": "Szybki atak z rzutem za 3 punkty w pierwszym tempie (Early Offense)",
    "description": "Przejście z obrony do ataku zakończone natychmiastowym rzutem z nieobsadzonego obwodu.",
    "category": "Szybki atak",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 301000000
    },
    "updatedAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 301000000
    }
  },
  {
    "id": "import-118-przepchane-przejscie-z-kontry-na-atak-pozycyjny-secondary-break",
    "name": "Przepchane przejście z kontry na atak pozycyjny (Secondary Break)",
    "description": "Płynne przejście z nieudanego szybkiego ataku do płynnego ataku 5v5 bez zatrzymywania piłki.",
    "category": "Szybki atak",
    "difficulty": "Średnie",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 391000000
    },
    "updatedAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 391000000
    }
  },
  {
    "id": "import-119-kontra-po-przechwycie-na-obwodzie",
    "name": "Kontra po przechwycie na obwodzie",
    "description": "Agresywny interception na obwodzie i natychmiastowy zryw sam na sam z koszem.",
    "category": "Szybki atak",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 545000000
    },
    "updatedAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 545000000
    }
  },
  {
    "id": "import-120-gra-5-na-4-z-docelowym-powrotem-5-obroncy-5v4-to-5v5-transition",
    "name": "Gra 5 na 4 z docelowym powrotem 5 obrońcy (5v4 to 5v5 Transition)",
    "description": "Przewaga 5v4 trwająca 6 sekund, po czym piąty obrońca wbiega na boisko wyrównując siły.",
    "category": "Szybki atak",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 6,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 640000000
    },
    "updatedAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 640000000
    }
  },
  {
    "id": "import-121-wyprowadzenie-pi-ki-pod-presja-po-celnym-koszu-inbound-run",
    "name": "Wyprowadzenie piłki pod presją po celnym koszu (Inbound Run)",
    "description": "Wyciągnięcie piłki z siatki po celnym koszu rywala i wypuszczenie szybkiego podania w 2 sekundy.",
    "category": "Szybki atak",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 734000000
    },
    "updatedAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 734000000
    }
  },
  {
    "id": "import-122-szybki-atak-wahad-owy-lauf-drill",
    "name": "Szybki atak wahadłowy (Lauf Drill)",
    "description": "Ciągły bieg po przekątnych z podaniami jednorącz na pełnej prędkości bez kozła.",
    "category": "Szybki atak",
    "difficulty": "Łatwe",
    "duration": 12,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 830000000
    },
    "updatedAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 830000000
    }
  },
  {
    "id": "import-123-wymuszenie-powrotu-do-obrony-transition-defense-drill",
    "name": "Wymuszenie powrotu do obrony (Transition Defense Drill)",
    "description": "Trzech atakujących traci piłkę i ma zadanie jak najszybciej zatrzymać pierwszego kozłującego.",
    "category": "Szybki atak",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 924000000
    },
    "updatedAt": {
      "_seconds": 1785357376,
      "_nanoseconds": 924000000
    }
  },
  {
    "id": "import-124-gra-11-zawodnikow-na-dwa-kosze-11-man-fastbreak",
    "name": "Gra 11 zawodników na dwa kosze (11-Man Fastbreak)",
    "description": "Dynamiczne, nieprzerwane ćwiczenie szybkich ataków 3v2 na obu koszach z rotacją graczy.",
    "category": "Szybki atak",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 5,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 69000000
    },
    "updatedAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 69000000
    }
  },
  {
    "id": "import-125-szybki-atak-z-wyjsciem-szerokim-skrzyd-ami-rim-run-wide-wings",
    "name": "Szybki atak z wyjściem szerokim skrzydłami (Rim Run & Wide Wings)",
    "description": "Środkowy wbiega prosto pod kosz, skrzydłowi biegną pod linie boczne, otwierając trumnę.",
    "category": "Szybki atak",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 163000000
    },
    "updatedAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 163000000
    }
  },
  {
    "id": "import-126-zastawienie-w-pojedynku-1-na-1-po-rzucie-trenera",
    "name": "Zastawienie w pojedynku 1 na 1 po rzucie trenera",
    "description": "Trener rzuca z obwodu, obrońca musi odnaleźć rywala, wykonać zastawienie i złapać piłkę.",
    "category": "Zbiórka",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 263000000
    },
    "updatedAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 263000000
    }
  },
  {
    "id": "import-127-walka-o-zbiorke-ofensywna-w-2-na-2",
    "name": "Walka o zbiórkę ofensywną w 2 na 2",
    "description": "Atakujący próbują ominąć zastawiających obrońców i zebrać piłkę w ataku z ponowieniem.",
    "category": "Zbiórka",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 352000000
    },
    "updatedAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 352000000
    }
  },
  {
    "id": "import-128-zbiorka-w-najwyzszym-punkcie-ze-chwytem-dwuracz",
    "name": "Zbiórka w najwyższym punkcie ze chwytem dwurącz",
    "description": "Iskok z miejscem do zbiórki na maksymalnej wysokości z mocnym dociągnięciem piłki do klatki.",
    "category": "Zbiórka",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 447000000
    },
    "updatedAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 447000000
    }
  },
  {
    "id": "import-129-wytracenie-pi-ki-na-obwod-tip-out-rebound",
    "name": "Wytrącenie piłki na obwód (Tip-out Rebound)",
    "description": "Gdy zbierający nie może opanować piłki chwytem, zbija ją wysoko na obwód do własnego obrońcy.",
    "category": "Zbiórka",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 595000000
    },
    "updatedAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 595000000
    }
  },
  {
    "id": "import-130-zbiorka-i-natychmiastowe-zabezpieczenie-pi-ki-chin-the-ball",
    "name": "Zbiórka i natychmiastowe zabezpieczenie piłki (Chin the ball)",
    "description": "Po zbiórce schowanie piłki pod brodę z szeroko rozstawionymi łokciami w celu ochrony przed rywalem.",
    "category": "Zbiórka",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 697000000
    },
    "updatedAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 697000000
    }
  },
  {
    "id": "import-131-gra-w-zastawianie-3-na-3-na-ma-ym-obszarze",
    "name": "Gra w zastawianie 3 na 3 na małym obszarze",
    "description": "Gra bez rzutów z dystansu, skupiona na fizycznej walce o pozycję pod koszem po każdym odbiciu.",
    "category": "Zbiórka",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 790000000
    },
    "updatedAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 790000000
    }
  },
  {
    "id": "import-132-dobijanie-pi-ki-o-tablice-z-wyskoku-board-taps",
    "name": "Dobijanie piłki o tablicę z wyskoku (Board Taps)",
    "description": "Wyskakiwanie raz za razem pod koszem i odbijanie piłki o deskę jedną dłonią przed jej chwytem.",
    "category": "Zbiórka",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 20,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 881000000
    },
    "updatedAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 881000000
    }
  },
  {
    "id": "import-133-wyjscie-z-cienia-zastawiajacego-swimming-move",
    "name": "Wyjście z cienia zastawiającego (Swimming move)",
    "description": "Wykorzystanie pracy ramion i pierwszego szybkiego kroku do ominięcia boksującego obrońcy.",
    "category": "Zbiórka",
    "difficulty": "Trudne",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 972000000
    },
    "updatedAt": {
      "_seconds": 1785357377,
      "_nanoseconds": 972000000
    }
  },
  {
    "id": "import-134-rebound-outlet-drill-w-trojkach",
    "name": "Rebound & Outlet Drill w trójkach",
    "description": "Zbiórka obronna, wyjście w tył i podanie otwierające do skrzydłowego na obwodzie.",
    "category": "Zbiórka",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 114000000
    },
    "updatedAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 114000000
    }
  },
  {
    "id": "import-135-bitwa-o-nieczytelne-zbiorki-loose-balls-rebounds",
    "name": "Bitwa o nieczytelne zbiórki (Loose Balls & Rebounds)",
    "description": "Trener rzuca piłkę w nieprzewidywalne miejsce na parkiecie, dwóch graczy rzuca się do walki na parkiet.",
    "category": "Zbiórka",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 204000000
    },
    "updatedAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 204000000
    }
  },
  {
    "id": "import-136-drabinka-koordynacyjna-szybkosc-stop-footwork",
    "name": "Drabinka koordynacyjna - Szybkość stóp (Footwork)",
    "description": "Sekwencje kroków na drabince (in-out, crossover, shuffle) rozwijające koordynację nóg.",
    "category": "Motoryka",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 305000000
    },
    "updatedAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 305000000
    }
  },
  {
    "id": "import-137-sprinty-wahad-owe-suicides-linie",
    "name": "Sprinty wahadłowe (Suicides / Linie)",
    "description": "Bieg od linii końcowej do linii rzutów wolnych, środka, przeciwległej i powrót na czas.",
    "category": "Motoryka",
    "difficulty": "Trudne",
    "duration": 12,
    "repetitions": 5,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 401000000
    },
    "updatedAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 401000000
    }
  },
  {
    "id": "import-138-skoki-plyometryczne-na-skrzynie-p-otki",
    "name": "Skoki plyometryczne na skrzynię / płotki",
    "description": "Skoki oburącz przez płotki z natychmiastowym odbiciem po wylądowaniu (praca nad mocą eksplozywną).",
    "category": "Motoryka",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 496000000
    },
    "updatedAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 496000000
    }
  },
  {
    "id": "import-139-bieg-z-oporem-gumy-rozciagliwej-resisted-sprints",
    "name": "Bieg z oporem gumy rozciągliwej (Resisted Sprints)",
    "description": "Sprinty na odległość 10 metrów z trenerem/partnerem trzymającym gumę oporową wokół bioder.",
    "category": "Motoryka",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 638000000
    },
    "updatedAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 638000000
    }
  },
  {
    "id": "import-140-dynamiczny-krok-obronny-z-pi-ka-lekarska",
    "name": "Dynamiczny krok obronny z piłką lekarską",
    "description": "Krok odstawno-dostawny w niskiej pozycji z trzymaniem piłki lekarskiej przed klatką piersiową.",
    "category": "Motoryka",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 724000000
    },
    "updatedAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 724000000
    }
  },
  {
    "id": "import-141-rzuty-pi-ka-lekarska-znad-g-owy-w-scinaniu",
    "name": "Rzuty piłką lekarską znad głowy w ścinaniu",
    "description": "Dynamiczne wyrzuty piłki lekarskiej oburącz do partnera z zaangażowaniem mięśni brzucha.",
    "category": "Motoryka",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 816000000
    },
    "updatedAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 816000000
    }
  },
  {
    "id": "import-142-praca-nad-mobilnoscia-bioder-i-stop",
    "name": "Praca nad mobilnością bioder i stóp",
    "description": "Zestaw ćwiczeń rozciągających dynamicznie staw biodrowy i skokowy zapobiegający kontuzjom.",
    "category": "Motoryka",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 908000000
    },
    "updatedAt": {
      "_seconds": 1785357378,
      "_nanoseconds": 908000000
    }
  },
  {
    "id": "import-143-zeskoki-i-ladowanie-jednonoz-deceleration-drill",
    "name": "Zeskoki i lądowanie jednonóż (Deceleration Drill)",
    "description": "Zeskok ze skrzyni na jedną nogę z amortyzacją kolana i utrzymaniem stabilnej pozycji ciała.",
    "category": "Motoryka",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 0
    },
    "updatedAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 0
    }
  },
  {
    "id": "import-144-szybkosciowy-tor-przeszkod-z-pi-ka",
    "name": "Szybkościowy tor przeszkód z piłką",
    "description": "Połączenie biegu przez pachołki, przeskoków i wykończenia rzutem na pełnym zmęczeniu.",
    "category": "Motoryka",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 168000000
    },
    "updatedAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 168000000
    }
  },
  {
    "id": "import-145-bieg-po-obwodzie-osemki-z-akcentem-na-zmiane-kierunku",
    "name": "Bieg po obwodzie ósemki z akcentem na zmianę kierunku",
    "description": "Sprint po ścieżce ósemki wokół dwóch pachołków z mocnym obniżeniem środka ciężkości.",
    "category": "Motoryka",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 258000000
    },
    "updatedAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 258000000
    }
  },
  {
    "id": "import-146-przysiady-eksplozywne-z-wyprosem-ramion-thrusters",
    "name": "Przysiady eksplozywne z wyprosem ramion (Thrusters)",
    "description": "Dynamiczny przysiad i wyciśnięcie obciążenia górą, angażujące całe taśmy mięśniowe.",
    "category": "Motoryka",
    "difficulty": "Trudne",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 357000000
    },
    "updatedAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 357000000
    }
  },
  {
    "id": "import-147-krok-zakroczny-z-rotacja-tu-owia-z-pi-ka",
    "name": "Krok zakroczny z rotacją tułowia z piłką",
    "description": "Ćwiczenie wzmacniające mięśnie korpusu (core) i stabilizację miednicy podczas starcia.",
    "category": "Motoryka",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 452000000
    },
    "updatedAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 452000000
    }
  },
  {
    "id": "import-148-test-zwrotnosci-10x5m-z-koz-em",
    "name": "Test zwrotności 10x5m z kozłem",
    "description": "Sprawdzian szybkości i zwrotności z ciągłym utrzymaniem kozłowania piłki koszykowej.",
    "category": "Motoryka",
    "difficulty": "Trudne",
    "duration": 10,
    "repetitions": 5,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 543000000
    },
    "updatedAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 543000000
    }
  },
  {
    "id": "import-149-stabilizacja-w-podporze-przodem-plank-variations",
    "name": "Stabilizacja w podporze przodem (Plank variations)",
    "description": "Warianty deski nakierowane na mięśnie głębokie brzucha niezbędne przy kontakcie fizycznym.",
    "category": "Motoryka",
    "difficulty": "Łatwe",
    "duration": 8,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 687000000
    },
    "updatedAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 687000000
    }
  },
  {
    "id": "import-150-wyskoki-dosiezne-do-tablicy-kosza-z-miejsca",
    "name": "Wyskoki dosiężne do tablicy / kosza z miejsca",
    "description": "Wyskoki pionowe oburącz nastawione na maksymalne wykorzystanie energii sprężystej.",
    "category": "Motoryka",
    "difficulty": "Średnie",
    "duration": 8,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "coach-import-xlsx",
    "createdBy": "Coach Import XLSX",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 780000000
    },
    "updatedAt": {
      "_seconds": 1785357379,
      "_nanoseconds": 780000000
    }
  },
  {
    "id": "izMy8wEfMIFVykeoY1bf",
    "name": "Kozioł pod presją w korytarzu (1v1)",
    "description": "Atakujący musi przeprowadzić piłkę przez wyznaczony pas boiska (korytarz 3m wide) przeciwko agresywnie kryjącemu obrońcy bez popełnienia straty.",
    "category": "Drybling",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 8,
    "youtubeUrl": "https://youtube.com/example/full-court-pressure",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 278000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "l6XJhnNjTXWySyaXA5Qx",
    "name": "Depth Jumps (Głębokie skoki z podestu)",
    "description": "Zeskok ze skrzyni/podestu (30-40 cm) na dwie nogi i natychmiastowe eksplozywne odbicie w górę z próbą sięgnięcia jak najwyższego punktu.",
    "category": "Motoryka i Wyskok",
    "difficulty": "Trudne",
    "duration": 10,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example/depth-jumps",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "lLj8UunXx4yI0aOD2QlG",
    "name": "Rzuty osobiste pod zmęczeniem",
    "description": "Wykonanie 2 rzutów wolnych po intensywnym sprincie przez długość boiska. Celem jest opanowanie oddechu i powtarzalność techniki w zmęczeniu.",
    "category": "Rzuty",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "https://youtube.com/example/free-throws-fatigue",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 278000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "nH0EDXIXAlHR7GZhN0f1",
    "name": "Wyjście do kontry w 3kach / Transition w 3kach",
    "description": "",
    "category": "Kondycja",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 0,
    "youtubeUrl": "",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "SYj5H1QmQ0evN9QIp5PyH1yFh6B3",
    "createdBy": "Unknown",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785852851,
      "_nanoseconds": 428000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "oKnpx42t2bR2MHgYxzlC",
    "name": "Warkocz na 3 graczy (Weave Drill)",
    "description": "Trzej zawodnicy przesuwają się przez całe boisko przekazując piłkę i ścinając za plecami podającego. Zakończenie szybkim dwutaktem lub rzutem.",
    "category": "Podania",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 5,
    "youtubeUrl": "https://youtube.com/example/3-man-weave",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 278000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "sKnj55zQZsVmZEKKgGzp",
    "name": "Skoki na skrzynię z miejsca (Box Jumps)",
    "description": "Eksplozywny skok oburącz z pozycji półprzysiadu na skrzynię plyometryczną z miękkim lądowaniem w pełnej kontroli i stabilizacji.",
    "category": "Motoryka i Wyskok",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 15,
    "youtubeUrl": "https://youtube.com/example/box-jumps",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "uIq2FmBEj3dYzUoJe7vi",
    "name": "Rolowanie wałkiem (Foam Rolling) kręgosłupa i nóg",
    "description": "Automasaż powięziowy z użyciem wałka na mięśnie czworogłowe pasmo biodrowo-piszczelowe łydki oraz odcinka piersiowego kręgosłupa.",
    "category": "Rozciąganie i Mobilność",
    "difficulty": "Łatwe",
    "duration": 10,
    "repetitions": 1,
    "youtubeUrl": "https://youtube.com/example/foam-rolling",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 280000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "va1XxovxYjj8x1nSuNnN",
    "name": "aa",
    "description": "",
    "category": "Ogólne",
    "difficulty": "Średnie",
    "duration": 10,
    "repetitions": 10,
    "youtubeUrl": "",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "demo-admin",
    "createdBy": "SYj5H1QmQ0evN9QIp5PyH1yFh6B3",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785186981,
      "_nanoseconds": 889000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "yk1XfhwoZ5ukodVzjme9",
    "name": "Drive and Kick (Penetracja i podanie na obwód)",
    "description": "Wjazd w pomalowane ze skrzydła sprowokowanie pomocy obrony i dynamiczne podanie omijające ('skip pass' lub 'pocket pass') do otwartego strzelca.",
    "category": "Podania",
    "difficulty": "Średnie",
    "duration": 12,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example/drive-and-kick",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 279000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  },
  {
    "id": "zCrYW24oJxwF6b2GJo93",
    "name": "Catch & Shoot po wyjściu ze zasłony (Pindown)",
    "description": "Gracz wykonuje ruch po zasłonie od dołu (pindown) odbiera podanie na obwodzie natychmiastowo układa stopy i oddaje rzut z dystansu.",
    "category": "Rzuty",
    "difficulty": "Trudne",
    "duration": 15,
    "repetitions": 12,
    "youtubeUrl": "https://youtube.com/example/pindown-shooting",
    "targetShotsThree": 20,
    "targetShotsTwo": 20,
    "targetFreeThrows": 20,
    "createdById": "EEgSt6YWQGMDXkIktDdcRzQ8zP83",
    "createdBy": "Krystian Stempniak",
    "visibilityScope": "all",
    "isPublic": true,
    "rating": 0,
    "usageCount": 0,
    "createdAt": {
      "_seconds": 1785268366,
      "_nanoseconds": 278000000
    },
    "updatedAt": "2026-08-06T16:25:41.767Z"
  }
];
